import React, { useEffect, useState } from "react";
import OtpInput from 'react-otp-input';


const SignUp = () => {
  const [index, setIndex] = useState(1);
  const [otp, setOtp] = useState('');

  console.log('index',index);
  return (
    <div className="signup_form">
      <div className="container">
        <div className="signup_wrapper">
          <div className="logo">
            <h2>#. Sign Up</h2>
          </div>

          {index == 1 && (
            <>
              <h3>Where is your Organization located?</h3>
              <p>We’ll use your location to set up your default alumni mangement systems, recommended apps, and more.</p>
              <div className="form_two">
                <div className="input_field_two">
                    <label htmlFor="">Country / Region *</label>
                    <select name="" id="">
                        <option value=""> - Select country / region- </option>
                        <option value="">India</option>
                        <option value="">Nepal</option>
                        <option value="">Shrilanka</option>
                        <option value="">UAE</option>
                        <option value="">USA</option>
                    </select>
                </div>
              </div>
            </>
          )}

          {index == 2 && (
            <>
              <h3>Create an Account</h3>
              <p>One last step before starting your free trial.</p>
              <div className="form_two">
                <div className="input_field_two">
                    <label htmlFor="">Email *</label>
                    <input type="email" name="" id="" placeholder="Enter email id here" />
                </div>
                <div className="input_field_two">
                    <label htmlFor="">Phone *</label>
                    <input type="number" name="" id="" placeholder="Enter phone number here"/>
                </div>
                <div className="input_field_two">
                    <label htmlFor="">Password</label>
                    <input type="password" name="" id="" placeholder="Enter password here"/>
                </div>
                <div className="input_button">
                    <button onClick={() => setIndex(index + 1)}>Create Account</button>
                </div>
              </div>
              <p className="privacy_policy">
                By proceeding, you agree to the <a href="http://" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> and <a href="http://" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              </p>
            </>
          )}

          {index == 3 && (
            <>
              <h3>Mobile Phone Verification</h3>
              <p>Enter the 6-digit verification code that was sent to your phone number.</p>
              <div className="form_otp">
                    <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        renderSeparator={<span>  </span>}
                        renderInput={(props) => <input {...props} />}
                        inputType="tel"
                        inputStyle={"otp_input_class"}
                    />
                     <button>Verify Account</button>
                    <p className="resend">
                        Didn't receive code? <b>Resend</b>
                    </p>
              </div>
            </>
          )}

         
          <div className="nav_controls">
            <div className="first">
                <button
                  className="btn_normal"
                  onClick={() => setIndex(index==1?1:index - 1)}
                >
                  <i class="fa-solid fa-angle-left"></i> Back
                </button>
            </div>
            <div className="second">
              {index <= 1 &&<button
                className="btn_colored"
                onClick={() => setIndex(index + 1)}
              >
                Next <i class="fa-solid fa-angle-right"></i>
              </button>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
